var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('column-button',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"selected":_vm.selected}})}
var staticRenderFns = []

export { render, staticRenderFns }